import { isRef, ref, unref } from "@nuxtjs/composition-api";
import { addShopProduct } from "@/services/product";
import { REQUEST_CODES } from "@/constants/const-http";
import { MessageBox } from "element-ui";
import { useLocalStorage } from "@vueuse/core";
import useMessage from "../../../composables/useMessage";
export default function useProductJoinShop(product_no) {
  const isInShop = ref(false);

  const Message = useMessage();
  async function onJoinShop() {
    await joinShop(unref(product_no));
  }

  async function joinShop(product_no) {
    const isShowTip = useLocalStorage("__show_shop_join_tip", true);
    let { code, msg } = await addShopProduct({
      product_no
    });
    if (code !== REQUEST_CODES.ERROR_OK) {
      Message.error(msg);
      throw new Error(msg);
    }
    isInShop.value = true;
    if (isShowTip.value + '' == 'true') {
      MessageBox.confirm(
        "加入店铺成功，可在商家中心-营销店铺中查看店铺中的所有在售产品。",
        "提示",
        {
          confirmButtonText: "知道了",
          cancelButtonText: "不再提示"
        }
      ).catch(() => {
        isShowTip.value = false;
      });
    } else {
      Message.success("加入店铺成功");
    }
  }

  function updateJoinShopStatus(flag) {
    isInShop.value = flag
  }

  return {
    isInShop,

    joinShop,
    onJoinShop,
    updateJoinShopStatus,
  };
}
